module.exports = __webpack_public_path__ + "img/phone-section-4.312bae82.png";